import React from 'react';
import { LogoMark } from './LogoMark';
interface LogoProps {
  tone?: 'light' | 'dark';
  className?: string;
}
export function Logo({
  tone = 'dark',
  className = ''
}: LogoProps) {
  const name = tone === 'light' ? 'text-porcelain' : 'text-aubergine';
  const sub = tone === 'light' ? 'text-copper-light' : 'text-copper-deep';
  return <span className={`flex items-center gap-3 ${className}`} data-id="element-43" data-mp="1rmjh47jjit11">
      <LogoMark tone={tone} className="h-9 w-9 shrink-0" data-id="element-44" data-mp="u0ce322vx8qs" />
      <span className="flex flex-col leading-none" data-id="element-45" data-mp="u1x90st42tp6">
        <span className={`font-display text-[17px] font-semibold uppercase tracking-[0.2em] transition-colors duration-200 ${name}`} data-id="element-46" data-mp="yzp1bnxo4htw">
          Aurevane
        </span>
        <span className={`mt-1.5 font-display text-[9.5px] font-semibold uppercase tracking-[0.34em] transition-colors duration-200 ${sub}`} data-id="element-47" data-mp="18wjstmvixhyo">
          Search Partners
        </span>
      </span>
    </span>;
}